export enum Language {
  en = 'en',
  es = 'es',
  pt = 'pt',
}

export type LanguageState = {
  currentLanguage: Language;
  supportedLanguages: Language[];
};
